import React, { useState, useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import Navbar from './components/Navbar';
import Home from './components/Home';
import CouponDeals from './components/CouponDeals';
import FAQPage from './components/FAQPage';
import Footer from './components/Footer';
import Login from './components/Login';
import Signup from './components/Signup';
import UserProfile from './components/UserProfile';
import Contact from './components/Contact';
import About from './components/About';
import Policy from './components/Policy';
import Cart from './components/Cart';
import Checkout from './components/Checkout';
import PurchasedCoupons from './components/PurchasedCoupons';
import RedeemedCoupons from './components/RedeemedCoupons';
import UserWallet from './components/UserWallet';
import SEO from './components/SEO';
import { CartProvider } from './services/CartContext';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState(() => {
    const path = window.location.pathname.replace(/^\//, '');
    return path === '' ? 'home' : path;
  });

  useEffect(() => {
    const handlePopState = () => {
      const path = window.location.pathname.replace(/^\//, '');
      setCurrentPage(path === '' ? 'home' : path);
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const handleNavigate = (page, sectionId) => {
    const targetPath = page === 'home' ? '/home' : `/${page}${sectionId ? `#${sectionId}` : ''}`;
    window.history.pushState(null, '', targetPath);
    setCurrentPage(page);
    if (sectionId) {
      setTimeout(() => {
        const el = document.getElementById(sectionId);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        } else {
          window.scrollTo(0, 0);
        }
      }, 150);
    } else {
      window.scrollTo(0, 0);
    }
  };

  // Redirect root path / to /home
  useEffect(() => {
    if (window.location.pathname === '/' || window.location.pathname === '') {
      window.history.replaceState(null, '', '/home');
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <CartProvider>
        <div className="App">
          <SEO currentPage={currentPage} />
          <Navbar onNavigate={handleNavigate} currentPage={currentPage} />
          {currentPage === 'home' && <Home onNavigate={handleNavigate} />}
          {currentPage === 'coupons' && <CouponDeals />}
          {currentPage === 'faq' && <FAQPage />}
          {currentPage === 'wallet' && <UserWallet onNavigate={handleNavigate} />}
          {currentPage === 'login' && <Login onNavigate={handleNavigate} />}
          {currentPage === 'signup' && <Signup onNavigate={handleNavigate} />}
          {currentPage === 'profile' && <UserProfile onNavigate={handleNavigate} />}
          {currentPage === 'checkout' && <Checkout onNavigate={handleNavigate} />}
          {currentPage === 'my-coupon' && <PurchasedCoupons onNavigate={handleNavigate} />}
          {currentPage === 'redeemed-coupons' && <RedeemedCoupons onNavigate={handleNavigate} />}
          {currentPage === 'contact' && <Contact />}
          {currentPage === 'about' && <About />}
          {currentPage === 'terms' && <Policy type="terms" />}
          {currentPage === 'privacy' && <Policy type="privacy" />}
          {currentPage === 'refund' && <Policy type="refund" />}
          {currentPage === 'cancellation' && <Policy type="cancellation" />}
          {currentPage !== 'login' && currentPage !== 'signup' && currentPage !== 'profile' && currentPage !== 'checkout' && currentPage !== 'my-coupon' && currentPage !== 'redeemed-coupons' && currentPage !== 'wallet' && <Footer onNavigate={handleNavigate} />}
          <Cart onNavigate={handleNavigate} />
        </div>
      </CartProvider>
    </ThemeProvider>
  );
}

export default App;
